/**
 * @generated SignedSource<<bc717e646787b45b83219f95accf5320>>
 * @relayHash 34a74ac66eca635c747712defb7a1657
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6802548f0450f01e61d3b291ad1d282e613f75cd3e5162911e8aa80457820733

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DeferEditionModalComponentQuery } from './DeferEditionModalComponentQuery.graphql';

const node: PreloadableConcreteRequest<DeferEditionModalComponentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6802548f0450f01e61d3b291ad1d282e613f75cd3e5162911e8aa80457820733",
    "metadata": {},
    "name": "DeferEditionModalComponentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
